import dayjs from 'dayjs';
import { StatusesType } from '../../../../../../types';

export interface IAccountDetailRes {
  id: number;
  status: StatusesType;
  campaignName: string;
  revDate: string; // '2024-01-15T00:00:00Z'
  appType: 'Monthly Statement' | 'Daily Letters' | string;
  scheduledDates: ScheduledDates;
}

export interface ScheduledDates {
  from: string;
  to: string;
}

export const accountDetailData: IAccountDetailRes[] = [
  {
    id: 108,
    status: 'draft',
    campaignName: 'Test Campaign',
    revDate: '2024-01-04',
    appType: 'Monthly Statement',
    scheduledDates: {
      from: '2024-01-10T00:00:00Z',
      to: '2024-01-16T00:00:00Z',
    },
  },
  {
    id: 106,
    status: 'draft',
    campaignName: 'VISA Classic - Refinance and save money',
    revDate: '2024-01-06',
    appType: 'Monthly Statement',
    scheduledDates: {
      from: '2024-01-21T00:00:00Z',
      to: '2024-02-01T00:00:00Z',
    },
  },
  {
    id: 104,
    status: 'draft',
    campaignName: 'Visa Business– REWARDS',
    revDate: '2024-01-07',
    appType: 'Monthly Statement',
    scheduledDates: {
      from: '2024-02-10T00:00:00Z',
      to: '2024-02-17T00:00:00Z',
    },
  },
  {
    id: 111,
    status: 'draft',
    campaignName: 'Visa Sweepstakes and closed accounts',
    revDate: '2024-01-08',
    appType: 'Monthly Statement',
    scheduledDates: {
      from: '2024-02-21T00:00:00Z',
      to: '2024-02-22T00:00:00Z',
    },
  },
  {
    id: 187,
    status: 'scheduled',
    campaignName: 'Visa Gold - Demo Auto Sale',
    revDate: '2024-01-10',
    appType: 'Monthly Statement',
    scheduledDates: {
      from: '2024-01-04T00:00:00Z',
      to: '2024-01-06T00:00:00Z',
    },
  },
  {
    id: 105,
    status: 'completed',
    campaignName: 'Visa Classic- Back to School Shopping',
    revDate: '2024-01-11',
    appType: 'Monthly Statement',
    scheduledDates: {
      from: '2024-01-07T00:00:00Z',
      to: '2024-02-08T00:00:00Z',
    },
  },
  {
    id: 115,
    status: 'completed',
    campaignName: 'Save Money on Your Loans',
    revDate: '2024-01-16',
    appType: 'Daily Letters',
    scheduledDates: {
      from: '2024-01-10T00:00:00Z',
      to: '2024-02-11T00:00:00Z',
    },
  },
];

interface IDataContent {
  id: string;
  date: string;
}

interface IData {
  id: string;
  title: string;
  content: IDataContent[];
}
const currentYear = dayjs().year();

export const accordionData: IData[] = [
  {
    id: '0',
    title: `Account Statements from ${currentYear - 1}`,
    content: [
      {
        id: '0',
        date: 'January 12',
      },
      {
        id: '1',
        date: 'February 25',
      },
      {
        id: '2',
        date: 'March 22',
      },
      {
        id: '3',
        date: 'April 14',
      },
      {
        id: '4',
        date: 'May 17',
      },
      {
        id: '5',
        date: 'June 28',
      },
      {
        id: '6',
        date: 'July 26',
      },
      {
        id: '7',
        date: 'August 11',
      },
      {
        id: '8',
        date: 'September 13',
      },
      {
        id: '9',
        date: 'October 15',
      },
      {
        id: '10',
        date: 'November 26',
      },
      {
        id: '11',
        date: 'December 23',
      },
    ],
  },
  {
    id: '1',
    title: `Account Statements from ${currentYear - 2}`,
    content: [
      {
        id: '0',
        date: 'January 23',
      },
      {
        id: '1',
        date: 'February 22',
      },
      {
        id: '2',
        date: 'March 24',
      },
      {
        id: '3',
        date: 'April 25',
      },
      {
        id: '4',
        date: 'May 26',
      },
      {
        id: '5',
        date: 'June 27',
      },
      {
        id: '6',
        date: 'July 11',
      },
      {
        id: '7',
        date: 'August 23',
      },
      {
        id: '8',
        date: 'September 13',
      },
      {
        id: '9',
        date: 'October 14',
      },
      {
        id: '10',
        date: 'November 16',
      },
      {
        id: '11',
        date: 'December 19',
      },
    ],
  },
];
